import React from "react";
import { Outlet } from "react-router-dom";

export default function CustomOutlet() {

  return (
    <div className="outlet-container">
      <Outlet />
    </div>
  );
}
